export default __webpack_public_path__ + "fonts/6xKodSZaM9iE8KbpRA_pgHYYT8L.woff2";